import React from 'react';
import styled from 'styled-components';
import { isFieldValid } from '../../utils/validation';
import { AnimatedValue } from './AnimatedValue';
const StyledText = styled.span `
  display: inline-block;
  background-color: ${({ theme }) => theme.animatedRed};
  color: ${({ theme }) => theme.primaryWhite};
  border-radius: 24px;
  padding: 3px 20px 0px 20px;
  min-width: 100px;
`;
export const BodyTextWithAnimatedValues = ({ field }) => {
    if (!isFieldValid(field)) {
        return null;
    }
    const styledRegex = /(<styled>.*?<\/styled>)/g;
    const animatedRegex = /(<animated>.*?<\/animated>)/g;
    const textValue = field.value;
    const bodyTextArray = textValue.split(styledRegex);
    const JSXArray = bodyTextArray.map((text, index) => {
        if (text.match(styledRegex)) {
            const styledText = text.replace(/<styled>/, '').replace(/<\/styled>/, '');
            if (styledText.match(animatedRegex)) {
                const splitAnimatedText = styledText.split(animatedRegex);
                const styledArray = splitAnimatedText.map((styledText, index) => {
                    if (styledText.match(animatedRegex)) {
                        const animatedValue = styledText.replace(/<animated>/, '').replace(/<\/animated>/, '');
                        return React.createElement(AnimatedValue, { key: index, value: Number(animatedValue) });
                    }
                    else {
                        return styledText;
                    }
                });
                return React.createElement(StyledText, { key: index }, styledArray);
            }
            else {
                return React.createElement(StyledText, { key: index }, styledText);
            }
        }
        else {
            return text;
        }
    });
    return React.createElement(React.Fragment, null, JSXArray);
};
